import React, { useEffect, useState } from 'react';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Slider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Hidden,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Drawers from '../../components/Drawers';
import Login from '../../components/reusableComponents/Login';
import TitleText from '../../components/reusableComponents/TitleText';
import BodyText from '../../components/reusableComponents/BodyText';
import flightpro from '../../assets/images/flightpro.png';
import spice from '../../assets/images/spice.gif';
import CardFlight from '../../components/reusableComponents/CardFlight';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlightDetailModal from '../../components/reusableComponents/FlightDetailModal';
import {
	setFilterData,
	setFlightData,
	setReturnFilterData,
	setReturnFlightData,
} from '../../reducers/UiReducer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useDispatch } from 'react-redux';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { useSelector } from 'react-redux';
import Skeleton from '@material-ui/lab/Skeleton';
import CardFlightReturn from '../../components/reusableComponents/CardFlightReturn';
import { useHistory, useLocation } from 'react-router-dom';
import { SearchReturnFormDispatch } from '../../reducers/HomeReducer';
import Header from '../../components/reusableComponents/Header';
import Home from '../../assets/images/home_hero_bg.jpg';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiChip-sizeSmall': {
			height: 36,
		},
	},
	accodin: {
		'& .MuiAccordionSummary-content': {
			justifyContent: 'space-between',
		},
	},
	searhform: {
		backgroundImage: `url(${Home})`,
		height: 272,
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		paddingTop: 124,
		[theme.breakpoints.down('xs')]: {
			height: 590,
		},
	},
}));

const GreenCheckbox = withStyles({
	root: {
		color: '#39c9bb',
		'&$checked': {
			color: '#39c9bb',
		},
	},
	checked: {},
})((props) => <Checkbox color='default' {...props} />);
const Flight = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const [expanded, setExpanded] = React.useState('');
	const [data, setData] = useState('');
	const [scrollVal, SetScrollVal] = useState(10);
	const [scrollValResult, SetScrollValResult] = useState(10);
	const [hasMoreresult, SethasMoreResult] = useState(true);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const [result, setResult] = useState([]);
	const [result2, setResult2] = useState([]);
	const { flightreturn, loading } = useSelector((state) => state.home);
	const { flightId, RflightId } = useSelector((state) => state.ui);
	const [check, setCheck] = useState(false);
	const [check2, setCheck2] = useState(false);
	const [check3, setCheck3] = useState(false);
	const [check4, setCheck4] = useState(false);
	const [check5, setCheck5] = useState(false);
	const [stop1, setStop1] = useState(false);
	const [stop2, setStop2] = useState(false);
	const [stop3, setStop3] = useState(false);
	const [morning, setMorning] = useState(false);
	const [dophar, setDOphar] = useState(false);
	const [value, setValue] = React.useState([1000, 5000]);
	const handleCheck = (event) => {
		setCheck(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		let checkData2 = [];
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
			console.log('check', checkData);
			if (check) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData2.push({
								...item,
							});
						}
					});
				});
			console.log('check2', checkData2);
			if (check) {
				setResult2([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const handleCheckGO = (event) => {
		setCheck2(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		let checkData2 = [];
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
			console.log('check', checkData);
			if (check2) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData2.push({
								...item,
							});
						}
					});
				});
			console.log('check2', checkData2);
			if (check2) {
				setResult2([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const handleCheckIndigo = (event) => {
		setCheck3(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		let checkData2 = [];
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
			console.log('check', checkData);
			if (check3) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData2.push({
								...item,
							});
						}
					});
				});
			console.log('check2', checkData2);
			if (check3) {
				setResult2([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const handleCheckAir = (event) => {
		setCheck4(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		let checkData2 = [];
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
			console.log('check', checkData);
			if (check4) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData2.push({
								...item,
							});
						}
					});
				});
			console.log('check2', checkData2);
			if (check4) {
				setResult2([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const handleCheckVistara = (event) => {
		setCheck5(event.target.checked);
		console.log(event.target.name);
		let checkData = [];
		let checkData2 = [];
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData.push({
								...item,
							});
						}
					});
				});
			console.log('check', checkData);
			if (check5) {
				setResult([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn && event.target.name) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					item.Segments[0].map((i) => {
						if (i.Airline.AirlineName === event.target.name) {
							checkData2.push({
								...item,
							});
						}
					});
				});
			console.log('check2', checkData2);
			if (check5) {
				setResult2([]);
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const handleOne = () => {
		let checkData = [];
		let checkData2 = [];
		if (flightreturn) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 1) {
						checkData.push({
							...item,
						});
					}
				});
			console.log('check', checkData);
			if (stop1) {
				setResult('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					if (item.Segments[0].length === 1) {
						checkData2.push({
							...item,
						});
					}
				});
			console.log('check2', checkData2);
			if (stop1) {
				setResult2('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const handleTwo = () => {
		let checkData = [];
		let checkData2 = [];
		if (flightreturn) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 2) {
						checkData.push({
							...item,
						});
					}
				});
			console.log('tWO', checkData);
			if (stop2) {
				setResult('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					if (item.Segments[0].length === 2) {
						checkData2.push({
							...item,
						});
					}
				});
			console.log('check2', checkData2);
			if (stop2) {
				setResult2('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const handleThree = () => {
		let checkData = [];
		let checkData2 = [];
		if (flightreturn) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[0].length > 0 &&
				flightreturn.data.Response.Results[0].map((item) => {
					if (item.Segments[0].length === 3) {
						checkData.push({
							...item,
						});
					}
				});
			console.log('check', checkData);
			if (stop3) {
				setResult('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult(checkData);
			}
		}
		if (flightreturn) {
			flightreturn &&
				flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results[1].length > 0 &&
				flightreturn.data.Response.Results[1].map((item) => {
					if (item.Segments[0].length === 3) {
						checkData2.push({
							...item,
						});
					}
				});
			console.log('check2', checkData2);
			if (stop3) {
				setResult2('');
				SetScrollVal(10);
				SetScrollValResult(10);
			} else {
				setResult2(checkData2);
			}
		}
	};
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const matches2 = useMediaQuery(theme.breakpoints.down('xs'));

	const handleChange = (panel) => (event, newExpanded) => {
		setExpanded(newExpanded ? panel : false);
	};

	let flight = [];
	let Returnflight = [];
	if (loading) {
		console.log('loading.............');
	} else {
		if (flightreturn) {
			flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results &&
				flightreturn.data.Response.Results[0].map((app, index) => {
					if (index === flightId) {
						flight.push({
							...app,
						});
					}
				});
		}
		if (flightreturn) {
			flightreturn.data &&
				flightreturn.data.Response &&
				flightreturn.data.Response &&
				flightreturn.data.Response.Results &&
				flightreturn.data.Response.Results[1].map((app, index) => {
					if (index === RflightId) {
						Returnflight.push({
							...app,
						});
					}
				});
		}
	}

	let filterData = [];
	filterData =
		flightreturn &&
		flightreturn.data &&
		flightreturn.data.Response &&
		flightreturn.data.Response.Results[0].length > 0 &&
		flightreturn.data.Response.Results[0].slice().sort((a, b) => {
			return a.Fare.BaseFare - b.Fare.BaseFare;
		});
	let ReturnfilterData = [];
	ReturnfilterData =
		flightreturn &&
		flightreturn.data &&
		flightreturn.data.Response &&
		flightreturn.data.Response.Results[1].length > 0 &&
		flightreturn.data.Response.Results[1].slice().sort((a, b) => {
			return a.Fare.BaseFare - b.Fare.BaseFare;
		});

	let onward = [];
	let returnD = [];

	if (loading) {
		console.log('loading.............222');
	} else {
		if (filterData) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((app, index) => {
					if (index === flightId) {
						onward.push({
							...app,
						});
					}
				});
		}
		if (ReturnfilterData) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((app, index) => {
					if (index === RflightId) {
						returnD.push({
							...app,
						});
					}
				});
		}
	}
	let resultSelection = [];
	let resultRSelection = [];
	if (loading) {
		console.log('loading............');
	} else {
		if (result) {
			result &&
				result.length > 0 &&
				result.map((app, index) => {
					if (index === flightId) {
						resultSelection.push({
							...app,
						});
					}
				});
		}
		if (result2) {
			result2 &&
				result2.length > 0 &&
				result2.map((app, index) => {
					if (index === RflightId) {
						resultRSelection.push({
							...app,
						});
					}
				});
		}
	}
	console.log('onward', onward);
	console.log('returnD', returnD);
	console.log('result', resultSelection);
	console.log('resultR', resultRSelection);
	console.log('Returnflight', Returnflight);
	const fetchMoreData = () => {
		if (scrollVal >= filterData.length) {
			SethasMoreFilterData(false);
		}
		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const fetchMoreDataResult = () => {
		if (scrollValResult >= filterData.length) {
			SethasMoreResult(false);
		}
		setTimeout(() => {
			SetScrollValResult(scrollValResult + 5);
		}, 500);
	};
	useEffect(() => {
		dispatch(setFlightData(flight.length == 1 ? flight : ''));
		dispatch(setReturnFlightData(flight.length == 1 ? Returnflight : ''));
		dispatch(setFilterData(flight.length == 1 ? filterData : ''));
		dispatch(setReturnFilterData(flight.length == 1 ? ReturnfilterData : ''));
	}, [loading]);
	useEffect(() => {
		if (location.state) {
			dispatch(SearchReturnFormDispatch(location.state.returnBody, history));
		}
	}, [dispatch]);
	const handlemorning = () => {
		let checkData = [];
		let checkData2 = [];
		if (filterData && filterData.length > 0) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (morning) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}

		if (ReturnfilterData && ReturnfilterData.length > 0) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 5 && b <= 12) {
						checkData2.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (morning) {
			setResult2([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult2(checkData2);
		}
		console.log('Morning', checkData);
	};
	const handledophar = () => {
		let checkData = [];
		let checkData2 = [];
		if (filterData && filterData.length > 0) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (dophar) {
			setResult([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult(checkData);
		}

		if (ReturnfilterData && ReturnfilterData.length > 0) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((item) => {
					console.log(
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Origin.DepTime.substr(11, 2);
						})
					);
					console.log(
						'Dept',
						item.Segments[0].slice(0, 1).map((i) => {
							return i.Destination.ArrTime.substr(11, 2);
						})
					);
					let a = item.Segments[0].slice(0, 1).map((i) => {
						return i.Origin.DepTime.substr(11, 2);
					});
					let b = item.Segments[0].slice(0, 1).map((i) => {
						return i.Destination.ArrTime.substr(11, 2);
					});
					if (a >= 12 && b <= 18) {
						checkData2.push({
							...item,
						});
					}
				});
		}
		console.log(checkData);
		if (dophar) {
			setResult2([]);
			SetScrollVal(10);
			SetScrollValResult(10);
		} else {
			setResult2(checkData2);
		}
		console.log('Morning', checkData);
	};
	const handleSlider = (event, newValue) => {
		setValue(newValue);
		console.log(newValue);
		let checkData = [];
		let checkData2 = [];
		if (filterData && newValue) {
			filterData &&
				filterData.length > 0 &&
				filterData.map((item) => {
					let a = item.Fare.BaseFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkData.push({
							...item,
						});
					}
				});
		}
		if (ReturnfilterData && newValue) {
			ReturnfilterData &&
				ReturnfilterData.length > 0 &&
				ReturnfilterData.map((item) => {
					let a = item.Fare.BaseFare;
					let b = newValue[0];
					let c = newValue[1];
					if (a >= b && a <= c) {
						checkData2.push({
							...item,
						});
					}
				});
		}

		setResult(checkData);
		setResult2(checkData2);
		SetScrollValResult(10);
		console.log('Slider Value', checkData);
	};
	console.log(location.state);
	console.log(filterData);
	console.log(ReturnfilterData);
	return (
		<>
			<Box
				style={{
					paddingTop: '10px',
					background: 'white',
					position: 'absolute',
					zIndex: 99,
					height: 60,
					top: 0,
					right: 0,
					bottom: 0,
					left: 0,
				}}>
				<Container>
					<Header />
				</Container>
			</Box>
			<Box
				style={{
					backgroundColor: '#515b62',
					marginTop: 75,
					color: 'white',
					padding: 5,
				}}>
				<Container>
					<Box display='flex'>
						<TitleText
							two
							textStyle={{
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							MusafirBazar Holiday /
						</TitleText>
						<TitleText
							two
							textStyle={{
								marginLeft: 5,
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							Flight /
						</TitleText>
					</Box>
				</Container>
			</Box>
			<Box
				className={classes.searhform}
				style={{ backgroundPosition: matches2 ? '' : '1px -443px' }}>
				<Container>
					{/* <InternalSearchForm item={location.state} /> */}
					{/* <InternalSearchForm item={location} /> */}
					{/* <InternalSearchForm /> */}
					{/* <RoundSearchForm /> */}
				</Container>
			</Box>
			<Box style={{ marginTop: 20 }}>
				<Container>
					<Box
						style={{
							textAlign: 'justify',
							border: '1px solid #d7d7d7',
							padding: 10,
							background: 'white',
						}}>
						<BodyText
							textStyle={{
								color: 'red',
								fontFamily: 'Josefin Sans, sans-serif',
								fontWeight: 500,
							}}>
							Important Information
						</BodyText>
					</Box>
					{/* <Box>
						<InternalSearchForm />
					</Box> */}
					<Box className={classes.accodin}>
						<Accordion
							square
							expanded={expanded === 'panel1'}
							onChange={handleChange('panel1')}>
							<AccordionSummary
								aria-controls='panel1d-content'
								id='panel1d-header'>
								<Box alignItems='center'>
									<TitleText
										two
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										Filter
									</TitleText>
								</Box>
								<Hidden only={['xs']}>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											STOPS
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											PRICE
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											AIRLINE
										</TitleText>
										<ExpandMoreIcon />
									</Box>
									<Box display='flex' alignItems='center'>
										<TitleText
											two={matches ? false : true}
											one={matches ? true : false}
											textStyle={{
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											DEPARTURE TIME
										</TitleText>
										<ExpandMoreIcon />
									</Box>
								</Hidden>
								<Box display='flex'>
									<TitleText
										two
										textStyle={{
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										RESET ALL
									</TitleText>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								<Grid container>
									<Grid item xs={12} lg={3}>
										<Box display={'flex'} style={{ padding: 10 }}>
											<Box
												onClick={() => {
													handleOne();
													stop1 ? setStop1(false) : setStop1(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop1 ? 'rgb(57, 201, 187)' : '#eee',
													color: stop1 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													cursor: 'pointer',
												}}>
												<BodyText>0</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleTwo();
													stop2 ? setStop2(false) : setStop2(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop2 ? 'rgb(57, 201, 187)' : '#eee',
													color: stop2 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText>1</BodyText>
											</Box>
											<Box
												onClick={() => {
													handleThree();
													stop3 ? setStop3(false) : setStop3(true);
												}}
												style={{
													width: '40px',
													padding: '6px 0px',
													background: stop3 ? 'rgb(57, 201, 187)' : '#eee',
													color: stop3 ? 'white' : '#666',
													border: '1px solid #ddd',
													borderRadius: '2px',
													fontWeight: 700,
													textAlign: 'center',
													marginLeft: 10,
													cursor: 'pointer',
												}}>
												<BodyText>2</BodyText>
											</Box>
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										{/* <Box display='flex'> */}
										<Box
											style={
												{
													// maxWidth: 300,
													// display: 'flex',
												}
											}>
											<Slider
												style={{ maxWidth: 500 }}
												value={value}
												min={1000}
												// step={1}
												max={10000}
												aria-label='Default'
												// valueLabelFormat={numFormatter}
												// marks={followersMarks}
												// scale={scaleValues}
												onChange={handleSlider}
												valueLabelDisplay='auto'
												aria-labelledby='non-linear-slider'
											/>
											<Box display='flex' justifyContent='space-between'>
												<BodyText>Min: {value[0]}</BodyText>
												<BodyText>Max: {value[1]}</BodyText>
											</Box>
										</Box>
										{/* </Box> */}

										{/* </Box> */}
									</Grid>
									<Grid item xs={12} lg={3}>
										<Box ml={'20px'} mt={matches ? '20px' : ''}>
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check}
														onChange={handleCheck}
														name='SpiceJet'
													/>
												}
												label='SpiceJet'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check2}
														onChange={handleCheckGO}
														name='GO FIRST'
													/>
												}
												label='GO FIRST'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check3}
														onChange={handleCheckIndigo}
														name='Indigo'
													/>
												}
												label='Indigo'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check4}
														onChange={handleCheckAir}
														name='Air Asia'
													/>
												}
												label='Air Asia'
											/>
											<br />
											<FormControlLabel
												control={
													<GreenCheckbox
														checked={check5}
														onChange={handleCheckVistara}
														name='Vistara'
													/>
												}
												label='Vistara'
											/>
											<br />
											{/* - */}
										</Box>
									</Grid>
									<Grid item xs={12} lg={3}>
										<Box display='flex' mt={matches ? '20px' : ''}>
											<Box
												onClick={() => {
													handlemorning();
													morning ? setMorning(false) : setMorning(true);
												}}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													background: morning ? 'rgb(57, 201, 187)' : '#8f8f8f',
													color: morning ? 'white' : '',
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													cursor: 'pointer',
													// background: '#8f8f8f',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														05-12
													</BodyText>
												</Box>
											</Box>
											<Box
												onClick={() => {
													handledophar();
													dophar ? setDOphar(false) : setDOphar(true);
												}}
												ml={'10px'}
												style={{
													display: 'block',
													padding: '6px 10px',
													textAlign: 'center',
													// font-size: var(--fnt-12);
													// color: var(--gray);
													borderRight: '1px solid #ddd',
													fontWeight: 700,
													cursor: 'pointer',
													background: dophar ? 'rgb(57, 201, 187)' : '#8f8f8f',
													color: dophar ? 'white' : '',
												}}>
												<WbSunnyIcon />
												<Box>
													<BodyText one textStyle={{ color: 'white' }}>
														12-18
													</BodyText>
												</Box>
											</Box>
										</Box>
									</Grid>
								</Grid>
							</AccordionDetails>
						</Accordion>
					</Box>
					<Grid
						container
						style={{ marginTop: 20, marginBottom: 140 }}
						spacing={2}>
						<Grid item xs={12} sm={6} lg={7}>
							<Grid container spacing={4}>
								<Hidden only={['xs', 'sm', 'md']}>
									<Grid item lg={4}>
										<Box>
											<img src={flightpro} width='100%' height='216px'></img>
										</Box>
									</Grid>
								</Hidden>

								<Grid item xs={12} lg={8}>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{
											background: '#eee',
											padding: '10px',
											borderBottom: '1px solid #ddd',
											margin: '0 0 15px',
										}}>
										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												DEPART
											</TitleText>
										</Box>
										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												ARRIVAL
											</TitleText>
										</Box>
										<Box>
											<TitleText one textStyle={{ color: '#666' }}>
												PRICE(Per Adult)
											</TitleText>
										</Box>
									</Box>
									<Box
										display='flex'
										justifyContent='space-between'
										style={{ padding: '5px', background: '#39c9bb' }}>
										<Box>
											<TitleText two textStyle={{ color: 'white' }}>
												{flight.length == 1
													? flight[0].Segments[0].map((i) => {
															return i.Origin.Airport.CityName;
													  })
													: ''}{' '}
												-{' '}
												{flight.length == 1
													? flight[0].Segments[0].map((i) => {
															return i.Destination.Airport.CityName;
													  })
													: ''}
											</TitleText>
											<TitleText two textStyle={{ color: 'white' }}>
												05-Feb-2022
											</TitleText>
										</Box>
										<Box display='flex'>
											<TitleText one>Prev</TitleText>
											<TitleText one>Next</TitleText>
										</Box>
									</Box>
									{/* <Box
										style={{
											padding: 10,
											boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
											background: 'rgba(57,201,187,.14)',
											border: '1px solid #39c9bb',
											color: '#666',
										}}>
										<Box display='flex' justifyContent='space-between'>
											<Box display='flex' alignItems='center'>
												<img src={spice} width='50px' height='25px'></img>
												<Box alignItems='center' ml={'5px'}>
													<TitleText two>SpiceJet</TitleText>
													<BodyText two>SG-2589</BodyText>
												</Box>
											</Box>
											<Box display='flex' alignItems='center'>
												<TitleText>Rs 8054</TitleText>
												<MoreVertIcon />
											</Box>
										</Box>
										<Box
											display='flex'
											justifyContent='space-between'
											alignItems='center'>
											<Box>
												<TitleText two>DEL</TitleText>
												<TitleText two>16:40</TitleText>
											</Box>
											<Box alignItems='center' textAlign='center'>
												<TitleText two>1hr 40mins</TitleText>
												<TitleText one>Non Stop</TitleText>
											</Box>
											<Box>
												<TitleText two>AMD</TitleText>
												<TitleText two>19:40</TitleText>
											</Box>
										</Box>
									</Box> */}
									{/* <Box
										style={{
											padding: '6px 10px',
											background: '#f5f6f6',
											borderBottomLeftRadius: '4px',
											borderBottomRightRadius: '4px',
											borderTop: '1px solid #e2e2e2',
											color: '#666',
										}}>
										<Box
											justifyContent='end'
											alignItems='center'
											display='flex'>
											<Box
												onClick={() => dispatch(toggleFlightModal(true))}
												display='flex'>
												<TitleText two>Flight Details</TitleText>
												<ArrowDropDownIcon />
											</Box>
										</Box>
									</Box> */}
									{/* {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => {
										return <CardFlight />;
									})} */}
									{loading ? (
										<>
											<Skeleton
												variant='rect'
												height='115px'
												style={{ marginTop: 5 }}
											/>
											<Skeleton
												variant='rect'
												height='115px'
												style={{ marginTop: 5 }}
											/>
											<Skeleton
												variant='rect'
												height='115px'
												style={{ marginTop: 5 }}
											/>
											<Skeleton
												variant='rect'
												height='115px'
												style={{ marginTop: 5 }}
											/>
											<Skeleton
												variant='rect'
												height='115px'
												style={{ marginTop: 5 }}
											/>
											<Skeleton
												variant='rect'
												height='115px'
												style={{ marginTop: 5 }}
											/>
										</>
									) : result && result.length > 0 ? (
										<InfiniteScroll
											dataLength={scrollValResult}
											next={fetchMoreDataResult}
											hasMore={hasMoreresult}
											loader={<h4>Loading...</h4>}
											endMessage={
												<p style={{ textAlign: 'center' }}>
													<b>No More Data</b>
												</p>
											}>
											{result.map((item, index) => {
												return index < scrollValResult ? (
													<CardFlight item={item} index={index} />
												) : (
													''
												);
											})}
										</InfiniteScroll>
									) : filterData && filterData.length > 0 ? (
										<InfiniteScroll
											dataLength={scrollVal}
											next={fetchMoreData}
											hasMore={hasMorefilterData}
											loader={<h4>Loading...</h4>}
											endMessage={
												<p style={{ textAlign: 'center' }}>
													<b>No More Data</b>
												</p>
											}>
											{filterData.map((item, index) => {
												return index < scrollVal ? (
													<CardFlight item={item} index={index} />
												) : (
													''
												);
											})}
										</InfiniteScroll>
									) : (
										flightreturn &&
										flightreturn.data &&
										flightreturn.data.Response &&
										flightreturn.data.Response.Results[0].length > 0 &&
										flightreturn.data.Response.Results[0].map((item, index) => {
											return <CardFlight item={item} index={index} />;
										})
									)}
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12} sm={6} lg={5}>
							<Box
								display='flex'
								justifyContent='space-between'
								style={{
									background: '#eee',
									padding: '10px',
									borderBottom: '1px solid #ddd',
									margin: '0 0 15px',
								}}>
								<Box>
									<TitleText one textStyle={{ color: '#666' }}>
										DEPART
									</TitleText>
								</Box>
								<Box>
									<TitleText one textStyle={{ color: '#666' }}>
										ARRIVAL
									</TitleText>
								</Box>
								<Box>
									<TitleText one textStyle={{ color: '#666' }}>
										PRICE(Per Adult)
									</TitleText>
								</Box>
							</Box>
							<Box
								display='flex'
								justifyContent='space-between'
								style={{ padding: '5px', background: '#39c9bb' }}>
								<Box>
									<TitleText two textStyle={{ color: 'white' }}>
										{Returnflight.length == 1
											? Returnflight[0].Segments[0].map((i) => {
													return i.Origin.Airport.CityName;
											  })
											: ''}{' '}
										-{' '}
										{Returnflight.length == 1
											? Returnflight[0].Segments[0].map((i) => {
													return i.Destination.Airport.CityName;
											  })
											: ''}
									</TitleText>
									<TitleText two textStyle={{ color: 'white' }}>
										05-Feb-2022
									</TitleText>
								</Box>
								<Box display='flex'>
									<TitleText one>Prev</TitleText>
									<TitleText one>Next</TitleText>
								</Box>
							</Box>
							{/* <Box
								style={{
									padding: 10,
									boxShadow: '3px 3px 16px -4px rgb(0 0 0 / 30%)',
									background: 'rgba(57,201,187,.14)',
									border: '1px solid #39c9bb',
									color: '#666',
								}}>
								<Box display='flex' justifyContent='space-between'>
									<Box display='flex' alignItems='center'>
										<img src={spice} width='50px' height='25px'></img>
										<Box alignItems='center' ml={'5px'}>
											<TitleText two>SpiceJet</TitleText>
											<BodyText two>SG-2589</BodyText>
										</Box>
									</Box>
									<Box alignItems='center' display='flex'>
										<TitleText>Rs 8054</TitleText>
										<MoreVertIcon />
									</Box>
								</Box>
								<Box
									display='flex'
									justifyContent='space-between'
									alignItems='center'>
									<Box>
										<TitleText two>DEL</TitleText>
										<TitleText two>16:40</TitleText>
									</Box>
									<Box alignItems='center' textAlign='center'>
										<TitleText two>1hr 40mins</TitleText>
										<TitleText one>Non Stop</TitleText>
									</Box>
									<Box>
										<TitleText two>AMD</TitleText>
										<TitleText two>19:40</TitleText>
									</Box>
								</Box>
							</Box> */}
							{/* <Box
								style={{
									padding: '6px 10px',
									background: '#f5f6f6',
									borderBottomLeftRadius: '4px',
									borderBottomRightRadius: '4px',
									borderTop: '1px solid #e2e2e2',
									color: '#666',
								}}>
								<Box justifyContent='end' alignItems='center' display='flex'>
									<Box
										onClick={() => dispatch(toggleFlightModal(true))}
										display='flex'>
										<TitleText two>Flight Details</TitleText>
										<ArrowDropDownIcon />
									</Box>
								</Box>
							</Box> */}
							{/* {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => {
								return <CardFlight />;
							})} */}
							{loading ? (
								<>
									<Skeleton
										variant='rect'
										height='115px'
										style={{ marginTop: 5 }}
									/>
									<Skeleton
										variant='rect'
										height='115px'
										style={{ marginTop: 5 }}
									/>
									<Skeleton
										variant='rect'
										height='115px'
										style={{ marginTop: 5 }}
									/>
									<Skeleton
										variant='rect'
										height='115px'
										style={{ marginTop: 5 }}
									/>
									<Skeleton
										variant='rect'
										height='115px'
										style={{ marginTop: 5 }}
									/>
									<Skeleton
										variant='rect'
										height='115px'
										style={{ marginTop: 5 }}
									/>
								</>
							) : // ) : ReturnfilterData && ReturnfilterData.length > 0 ? (
							// 	ReturnfilterData.map((item, index) => {
							// 		return <CardFlightReturn item={item} index={index} />;
							// 	})CND4235JQ2
							result2 && result2.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollValResult}
									next={fetchMoreDataResult}
									hasMore={hasMoreresult}
									loader={<h4>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Data</b>
										</p>
									}>
									{result2.map((item, index) => {
										return index < scrollValResult ? (
											<CardFlightReturn item={item} index={index} />
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : ReturnfilterData && ReturnfilterData.length > 0 ? (
								<InfiniteScroll
									dataLength={scrollVal}
									next={fetchMoreData}
									hasMore={hasMorefilterData}
									loader={<h4>Loading...</h4>}
									endMessage={
										<p style={{ textAlign: 'center' }}>
											<b>No More Data</b>
										</p>
									}>
									{ReturnfilterData.map((item, index) => {
										return index < scrollVal ? (
											<CardFlightReturn item={item} index={index} />
										) : (
											''
										);
									})}
								</InfiniteScroll>
							) : (
								flightreturn &&
								flightreturn.data &&
								flightreturn.data.Response &&
								flightreturn.data.Response.Results[1].length > 0 &&
								flightreturn.data.Response.Results[1].map((item, index) => {
									return <CardFlightReturn item={item} index={index} />;
								})
							)}
						</Grid>
					</Grid>
				</Container>
			</Box>
			<Box
				style={{
					position: 'fixed',
					bottom: 0,
					left: 0,
					right: 0,
					padding: '10px 0',
					background: 'black',
					color: '#bbb',
					zIndex: 9,
				}}>
				<Container>
					<Grid container>
						<Hidden only={['xs', 'sm']}>
							<Grid item xs={3}>
								<Box display='flex' justifyContent='space-between'>
									<Box>
										<TitleText
											two
											textStyle={{
												color: 'white',
												fontFamily: 'Josefin Sans, sans-serif',
												fontWeight: 500,
											}}>
											Your Selection
										</TitleText>
										<BodyText
											one
											textStyle={{ fontFamily: 'Roboto Serif, sans-serif' }}>
											(Special return air fares for booking both ways on same
											LCC airlines.)
										</BodyText>
									</Box>
									<div
										style={{ borderLeft: '3px solid grey', height: 80 }}></div>
								</Box>
							</Grid>
						</Hidden>

						<Grid item xs={matches ? 4 : 3}>
							<Box
								display='flex'
								justifyContent='space-between'
								style={{ paddingLeft: 5 }}>
								<Box>
									<BodyText
										two
										textStyle={{
											color: 'white',
											fontFamily: 'Josefin Sans, sans-serif',
										}}>
										Onwards
									</BodyText>
									<img
										src={spice}
										width='50px'
										height='25px'
										style={{ marginTop: 5 }}></img>
								</Box>
								<Box display='flex' justifyContent='space-between' ml={'5px'}>
									<Box>
										<Box display={'flex'}>
											<BodyText two textStyle={{ color: 'white' }}>
												{resultSelection.length == 1
													? resultSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Airline.AirlineName;
															})
													: onward.length == 1
													? onward[0].Segments[0].map((i) => {
															return i.Airline.AirlineName;
													  })
													: ''}
											</BodyText>
											<div
												style={{
													borderLeft: '2px solid grey',
													height: 20,
													marginLeft: 10,
													marginRight: 10,
												}}></div>
											<BodyText two textStyle={{ color: 'white' }}>
												{' '}
												{resultSelection.length == 1
													? resultSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Airline.AirlineCode;
															})
													: onward.length == 1
													? onward[0].Segments[0].map((i) => {
															return i.Airline.AirlineCode;
													  })
													: ''}
												-
												{resultSelection.length == 1
													? resultSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Airline.Flight;
															})
													: onward.length == 1
													? onward[0].Segments[0].map((i) => {
															return i.Airline.Flight;
													  })
													: ''}
											</BodyText>
										</Box>
										<Box
											display='flex'
											justifyContent='space-around'
											mt={'10px'}>
											<BodyText two textStyle={{ color: 'white' }}>
												{resultSelection.length == 1
													? resultSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Origin.DepTime.substr(11, 5);
															})
													: onward.length == 1
													? onward[0].Segments[0].map((i) => {
															return i.Origin.DepTime.substr(11, 5);
													  })
													: ''}
											</BodyText>
											<BodyText two textStyle={{ color: 'white' }}>
												{resultSelection.length == 1
													? resultSelection[0].Segments[0]
															.filter((f, index) => index == 1)
															.map((i) => {
																return i.Destination.ArrTime.substr(11, 5);
															})
													: onward.length == 1
													? onward[0].Segments[0].map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
													  })
													: ''}
											</BodyText>
										</Box>
									</Box>
								</Box>
								<Box>
									<BodyText two>07-Feb-2022</BodyText>
									<TitleText
										textStyle={{ color: 'white', marginLeft: 5, marginTop: 5 }}>
										Rs {''}
										{resultSelection.length == 1
											? resultSelection[0].Fare.BaseFare
											: onward.length == 1
											? onward[0].Fare.BaseFare
											: ''}
									</TitleText>
								</Box>
								<div style={{ borderLeft: '3px solid grey', height: 80 }}></div>
							</Box>
						</Grid>
						<Grid item xs={matches ? 4 : 3}>
							<Box
								display='flex'
								justifyContent='space-between'
								style={{ paddingLeft: 5 }}>
								<Box>
									<BodyText
										two
										textStyle={{
											color: 'white',
											fontFamily: 'Josefin Sans, sans-serif',
										}}>
										Return
									</BodyText>
									<img
										src={spice}
										width='50px'
										height='25px'
										style={{ marginTop: 5 }}></img>
								</Box>
								<Box display='flex' justifyContent='space-between' ml={'5px'}>
									<Box>
										<Box display={'flex'}>
											<BodyText two textStyle={{ color: 'white' }}>
												{resultRSelection.length == 1
													? resultRSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Airline.AirlineName;
															})
													: returnD.length == 1
													? returnD[0].Segments[0].map((i) => {
															return i.Airline.AirlineName;
													  })
													: ''}
											</BodyText>
											<div
												style={{
													borderLeft: '2px solid grey',
													height: 20,
													marginLeft: 10,
													marginRight: 10,
												}}></div>
											<BodyText two textStyle={{ color: 'white' }}>
												{' '}
												{resultRSelection.length == 1
													? resultRSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Airline.AirlineCode;
															})
													: returnD.length == 1
													? returnD[0].Segments[0].map((i) => {
															return i.Airline.AirlineCode;
													  })
													: ''}
												-
												{resultRSelection.length == 1
													? resultRSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Airline.Flight;
															})
													: returnD.length == 1
													? returnD[0].Segments[0].map((i) => {
															return i.Airline.Flight;
													  })
													: ''}
											</BodyText>
										</Box>
										<Box
											display='flex'
											justifyContent='space-around'
											mt={'10px'}>
											<BodyText two textStyle={{ color: 'white' }}>
												{resultRSelection.length == 1
													? resultRSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Origin.DepTime.substr(11, 5);
															})
													: returnD.length == 1
													? returnD[0].Segments[0].map((i) => {
															return i.Origin.DepTime.substr(11, 5);
													  })
													: ''}
											</BodyText>
											<BodyText two textStyle={{ color: 'white' }}>
												{resultRSelection.length == 1
													? resultRSelection[0].Segments[0]
															.filter((f, index) => index == 0)
															.map((i) => {
																return i.Destination.ArrTime.substr(11, 5);
															})
													: returnD.length == 1
													? returnD[0].Segments[0].map((i) => {
															return i.Destination.ArrTime.substr(11, 5);
													  })
													: ''}
											</BodyText>
										</Box>
									</Box>
								</Box>
								<Box>
									<BodyText two>07-Feb-2022</BodyText>
									<TitleText
										textStyle={{ color: 'white', marginLeft: 5, marginTop: 5 }}>
										Rs{' '}
										{resultRSelection.length == 1
											? resultRSelection[0].Fare.BaseFare
											: returnD.length == 1
											? returnD[0].Fare.BaseFare
											: ''}
									</TitleText>
								</Box>
								<div style={{ borderLeft: '3px solid grey', height: 80 }}></div>
							</Box>
						</Grid>
						<Grid item xs={matches ? 4 : 3}>
							<Box display='flex' justifyContent='space-between'>
								<Box>
									<TitleText
										two
										textStyle={{
											color: 'white',
											marginLeft: 5,
											fontFamily: 'Josefin Sans, sans-serif',
											fontWeight: 500,
										}}>
										Total Amount
									</TitleText>

									<TitleText textStyle={{ color: '#f56d6d', marginLeft: 5 }}>
										{/* {(flight.length == 1 ? flight[0].Fare.BaseFare : '') +
											(2)} */}
										{`Rs ${
											(resultRSelection.length == 1
												? resultRSelection[0].Fare.BaseFare
												: onward.length == 1
												? onward[0].Fare.BaseFare
												: '') +
											(resultRSelection.length == 1
												? returnD[0].Fare.BaseFare
												: returnD.length == 1
												? returnD[0].Fare.BaseFare
												: '')
										}`}
									</TitleText>
								</Box>
								<Box
									onClick={() => {
										history.push({
											pathname: '/flightsummary',
											state: {
												flightData:
													resultSelection.length == 1
														? resultSelection
														: onward.length == 1
														? onward
														: '',
												Returnflight:
													resultRSelection.length == 1
														? resultRSelection
														: returnD.length == 1
														? returnD
														: '',
												returnBody: location.state.returnBody,
												ID:
													flightreturn &&
													flightreturn.result &&
													flightreturn.result.Response &&
													flightreturn.result.Response.TraceId,
											},
										});
									}}
									textAlign='center'
									style={{
										color: 'white',
										background: '#39c9bb',
										padding: '16px 18px',
										borderRadius: 8,
										cursor: 'pointer',
										fontFamily: 'Josefin Sans, sans-serif',
										fontWeight: 500,
										boxShadow: '3px 3px 12px -6px rgb(0 0 0 / 70%)',
									}}>
									<TitleText>Book Now</TitleText>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Container>
			</Box>
			<FlightDetailModal />
			<Drawers />
			<Login />
		</>
	);
};

export default Flight;
